const COMMERCIAL_AT_SYMBOL = "@";

export const getUserNameFromEmailAddress = (email: string): string => {
  if (!email.includes(COMMERCIAL_AT_SYMBOL)) return email;

  return email.split(COMMERCIAL_AT_SYMBOL)[0];
};
